import { IncomeModel, IncomeType } from '../api/useIncomeQuery';
import { getClonedIncomeName } from '../Income.meta';
import { dataToForm as employmentDataToForm, formToBody as employmentFormToBody } from '../forms/Employment/EmploymentForm.meta';
import { dataToForm as otherIncomeDataToForm, formToBody as otherIncomeFormToBody } from '../forms/OtherIncome/OtherIncomeForm.meta';
import { IncomeData } from '../useIncome';

interface Params {
  clientId: string;
  income: IncomeModel;
  data: IncomeData;
}

export const buildCloneIncomeBody = ({ clientId, income, data }: Params) => {
  const incomeTitle =
    data.Options.IncomeTypeOptions.find(option => option.value === income.IncomeType)?.label ||
    'Income';
  const clonedName = getClonedIncomeName({ incomeName: income.Name, incomeTitle });

  switch (income.IncomeType) {
    case IncomeType.Salary: {
      const formValues = employmentDataToForm(income, data);

      return {
        clientId,
        ...employmentFormToBody(formValues),
        Name: clonedName,
        id: null,
        incomeType: IncomeType.Salary,
      };
    }

    case IncomeType.Other: {
      const formValues = otherIncomeDataToForm(income, data);

      return {
        clientId,
        ...otherIncomeFormToBody(formValues),
        name: clonedName,
        id: null,
        incomeType: IncomeType.Other,
      };
    }

    default:
      return null;
  }
};
